<div [@inOutAnimation] *ngIf="isShow" class="message-report-sent-wrapper">
    <div class="message-report-sent-wrapper__close">
        <ca-cross-button (click)="closeNotify.emit()" size="small"></ca-cross-button>
    </div>
    <ng-content></ng-content>
</div>
